"use strict";

exports.__esModule = true;
exports.activatePlugin = activatePlugin;
var installedPlugins = exports.installedPlugins = [];
var installedPluginHash = {};

function activatePlugin(plugin) {
  if (!installedPluginHash[plugin.name]) {
    installedPlugins.push(plugin);

    installedPluginHash[plugin.name] = true;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/kea/es/kea/plugins/index.js
// module id = 218
// module chunks = 2